import Request from "../helper/requestUtil";

interface IRequestBuilder {
  baseUrl: string;
  headers?: {}
}

class RequestBuilder {
  private props: IRequestBuilder;

  constructor() {
    this.props = {
      baseUrl: "",
      headers: {}
    };
    this.detectBaseUrlBaseOnEnv();
  }

  detectBaseUrlBaseOnEnv() {
    switch (process.env.REACT_APP_ENVIRONMENT) {
      case "local":
        return this;
      case "development":
        this.props.baseUrl = `${process.env.REACT_APP_BASE_URL}`;
        return this;
      case "production" :
        this.props.baseUrl = `${process.env.REACT_APP_BASE_URL}`;
        return this;
      default:
        return this;
    }
  }

  withHeaders(headers: {}): RequestBuilder {
    this.props.headers = headers;
    return this;
  }

  build(): Request {
    return new Request(this.props.baseUrl, this.props.headers)
  }
}

const request = new RequestBuilder();
export default request;
